import React from 'react';
import PropTypes from 'prop-types';

import styles from './dayPlanner.scss';
import useCloseAnimation from '../../../components/hooks/useCloseAnimation';

const DayPlannerSidePanel = (props) => {
    const {
        className,
        allowCloseOnClickOutside,
        closeSideBar,
        children,
        isVisible,
        onClose,
        'data-testid': dataTestId,
    } = props;

    const { isClosed, isClosing } = useCloseAnimation({ isVisible, onClose });

    const handleClose = () => {
        closeSideBar();
    };

    const onClickOutsideSideBar = () => {
        if (allowCloseOnClickOutside) {
            handleClose();
        }
    };

    if (isClosed) {
        return null;
    }

    return (
        <div className={`${styles.dayPlannerSidePanel} ${className}`}>
            <div className="flex-1" onClick={onClickOutsideSideBar} data-testid={dataTestId && `${dataTestId}.overlay`} />
            <div className={`${styles.panelContent} ${isClosing ? styles.closing : styles.opening}`} data-testid={dataTestId}>
                {children}
            </div>
        </div>
    );
};

DayPlannerSidePanel.propTypes = {
    className: PropTypes.string,
    allowCloseOnClickOutside: PropTypes.bool,
    closeSideBar: PropTypes.func,
    children: PropTypes.node.isRequired,
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    'data-testid': PropTypes.string,
};

DayPlannerSidePanel.defaultProps = {
    className: '',
    allowCloseOnClickOutside: false,
    closeSideBar: () => {},
    isVisible: true,
    onClose: null,
    'data-testid': undefined,
};

export default DayPlannerSidePanel;
